const TENDER_FORM_DATA = {
  name: '',
  description: null,
  address: null,
  offers_deadline_date: '',
  public_budget: null,
  internal_budget: null,
  row_ids: [],
  contractors: [],
  file_ids: [],
  is_advanced_pricing_enabled: false,
  offers: [],
  taxes: [],
};

export default TENDER_FORM_DATA;
